import { useEffect, useRef } from "react";

const Adsense = () => {
  const adLoaded = useRef(false);

  useEffect(() => {
    if (!adLoaded.current) {
      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        adLoaded.current = true;
      } catch (e) {
        console.error(e);
      }
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-5162535306990850"
      data-ad-slot="1526674088"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default Adsense;